//
//
//
//
//
//
//
//
//
//
//

import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: {
    ElImageViewer: ElImageViewer
  },
  data: function data() {
    return {
      visible: false,
      imageList: [],
      index: 0,
      tips: ''
    };
  },
  watch: {},
  methods: {
    open: function open() {
      this.visible = true;
    },
    onClose: function onClose() {
      this.imageList = [];
      this.tips = "";
      this.index = 0;
      this.visible = false;
    }
  }
};